// extracted by mini-css-extract-plugin
export default {"modal":"SendTestsMessageModal-module__modal__bYQ5E","content":"SendTestsMessageModal-module__content__+xXE-","alert":"SendTestsMessageModal-module__alert__9cLhF"};